<template>
  <div
    class="max-w-[200px] inline-flex items-center cursor-pointer select-none rounded-t p-1.5 relative border-l border-t last:border-r shadow"
    :class="{
      'bg-primary border-primary': active,
      'hover:text-primary': !active
    }"
  >
    <span
      class="window-tab px-2 truncate text-xs font-medium tracking-tighter"
      :class="{ italic: !pinned }"
    >
      {{ title }}
    </span>
    <AppIcon
      icon="fa-regular fa-close"
      class="window-tab-close cursor-pointer p-1 ml-auto rounded"
      :class="{
        'hover:bg-black/10': active,
        'hover:bg-gray-100 hover:text-primary': !active
      }"
      @click.stop="$emit('close')"
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  title: string;
  pinned?: boolean;
  active?: boolean;
}>();

const { title, pinned, active } = toRefs(props);
defineEmits<{
  (e: "close"): void;
}>();
</script>

<style scoped></style>
